<nb-card style="width: 50rem; max-height: 48rem">
  <nb-card-header>
    <app-card-header-content
      heading="Create Project"
      [dialogRef]="dialogRef"
    ></app-card-header-content>
  </nb-card-header>
  <nb-card-body>
    <form [formGroup]="projectForm" tabindex="0">
      <!-- Project Name -->
      <app-reactive-form-field
        label="Project Name"
        placeholder="Enter Project Name"
        [customFormControl]="blueprintName"
        [required]="true"
        labelSize="4"
        inputSize="7"
        formMargin="4"
        maxlength="20"
        missingMsg="Project name is required!"
        invalidPatternMsg="Project name should be lowercase alphanumeric starting with an alphabet and can only have hyphens!"
        patternMatch="[a-z]+[a-z0-9\-]*"
        [showInfoAsTooltip]="false"
        tooltipText="What should we call your project?"
      ></app-reactive-form-field>

      <!-- Project Description -->
      <app-reactive-text-area
        label="Description"
        placeholder="Add description"
        [customFormControl]="description"
        labelSize="4"
        inputSize="7"
        formMargin="4"
        rows="2"
        [showInfoAsTooltip]="false"
        tooltipText="What's your project about? Tell us more"
      ></app-reactive-text-area>

      <!-- Choose Account -->
      <div class="form-group row">
        <app-custom-form-label
          class="weight-600 col-md-4 col-xs-12"
          label="Choose Account"
          [required]="true"
          toolTip="Choose account where a new repository will be created for this project"
          [showInfoAsTooltip]="false"
        ></app-custom-form-label>
        <div class="col-md-1"></div>
        <div class="col-md-7 col-xs-12 d-flex flex-column">
          <app-account-selection-dropdown
            [customFormControl]="vcsAccount"
            accountType="VERSION_CONTROL"
            (afterAccountSave)="afterAccountSave($event)"
          ></app-account-selection-dropdown>
          <div class="mt-2" *ngIf="vcsAccount?.invalid && vcsAccount?.touched">
            <p
              class="caption status-danger"
              *ngIf="vcsAccount?.errors?.required"
            >
              Account id is required!
            </p>
          </div>
        </div>
      </div>

      <!-- Organization Name -->
      <app-single-select-search
        *ngIf="vcsAccountId && !selectedAccount?.app"
        label="{{
          selectedAccount?.app
            ? workspaceMap[selectedAccount?.provider]
            : 'Organization'
        }} Name"
        [showInfoAsTooltip]="false"
        inputSize="7"
        labelSize="5"
        [options]="orgNames"
        searchInputPlaceholder="Search {{
          selectedAccount?.app
            ? workspaceMap[selectedAccount?.provider]
            : 'Organization'
        }} Name"
        [selectInputPlaceholder]="
          orgNames?.length === 0
            ? 'No ' +
              (selectedAccount?.app
                ? workspaceMap[selectedAccount?.provider]
                : 'Organization') +
              ' Present'
            : 'Select ' +
              (selectedAccount?.app
                ? workspaceMap[selectedAccount?.provider]
                : 'Organization')
        "
        [showInfoAsTooltip]="false"
        [tooltipText]="selectedAccount?.app ? appOrgMessage : null"
        searchInputId="orgNames"
        [loading]="loadingOrgNames"
        [disabled]="orgNames?.length === 0 || selectedAccount?.app"
        [customFormControl]="selectedOrgName"
        [required]="this.selectedAccountProvider === 'BITBUCKET'"
      ></app-single-select-search>

      <app-reactive-form-field
        *ngIf="
          vcsAccountId && selectedAccount?.app && this.selectedOrgName?.value
        "
        label="{{
          selectedAccount?.app
            ? workspaceMap[selectedAccount?.provider]
            : 'Organization'
        }} Name"
        [customFormControl]="selectedOrgName"
        [required]="false"
        labelSize="4"
        inputSize="7"
        formMargin="4"
        tooltipText="This is pre-selected based on your linked 'Git' account"
        [showInfoAsTooltip]="false"
      ></app-reactive-form-field>

      <!-- Project Key -->
      <app-reactive-form-field
        *ngIf="
          vcsAccountId &&
          selectedAccount?.app &&
          selectedAccount?.projectKey &&
          selectedAccount?.provider === 'BITBUCKET'
        "
        label="Project Key"
        placeholder="Enter Project Key"
        [customFormControl]="bitbucketProjectKey"
        [disabled]="true"
        [required]="false"
        labelSize="4"
        inputSize="7"
        formMargin="4"
        tooltipText="This is pre-selected based on your linked 'Git' account"
        missingMsg="Project Key is required!"
        [showInfoAsTooltip]="false"
      ></app-reactive-form-field>

      <!-- Project Types -->
      <app-reactive-form-field
        label="Project Types"
        placeholder="{{ projectTypeName || 'Select Project Type' }}"
        [customFormControl]="projectType"
        [loading]="loadingProject"
        [required]="true"
        labelSize="4"
        inputSize="7"
        formMargin="4"
        [select]="true"
        [selectValues]="allProjectTypesOptions"
        [showInfoAsTooltip]="false"
        [disabled]="allProjectTypes?.length === 1"
        tooltipText="Choose a Project Type on which you will be building this new Project"
        (change)="onSelectProjectType($event)"
        (iconClick)="showProjectTypeDetails($event)"
      ></app-reactive-form-field>

      <!-- Allowed cloud -->
      <app-select-single-search
        selectInputLabel="Allowed Clouds"
        [showInfoAsTooltip]="false"
        selectInputPlaceholder="Select Clouds"
        searchInputPlaceholder="Search Cloud Options"
        selectTooltipText="Which cloud provider will host your project?"
        [multiple]="true"
        [required]="true"
        inputColSize="7"
        formMargin="4"
        labelColSize="5"
        [showSuffixIcon]="true"
        [options]="cloudProviderOptions"
        [showSearchBar]="false"
        selectionTextLabel="cloud"
        (selectedOptionEvent)="onCloudSelect($event)"
      ></app-select-single-search>
      <div class="mt-4"></div>

      <!-- Cluster creation -->
      <div class="formGroup row mb-3">
        <app-custom-form-label
          class="col-4"
          label="Environments"
          toolTip=""
          [showInfoAsTooltip]="false"
          toolTip="Would you like to create these environments now? You can always do it later."
        ></app-custom-form-label>
        <div class="col-1"></div>
        <div class="col-7" formGroupName="draftClusters">
          <nb-checkbox
            class="subtitle-2 mr-5"
            formControlName="{{ env }}"
            *ngFor="let env of envsOption"
            >{{ env }}
          </nb-checkbox>
        </div>
      </div>

      <app-reactive-toggle
        label="Import Project"
        labelSize="3"
        toggleSize="7"
        [customFormControl]="creationType"
        [showInfoAsTooltip]="false"
        (change)="onChangeProjectStatus($event)"
        [required]="false"
      ></app-reactive-toggle>

      <!-- Git URL -->
      <app-reactive-form-field
        *ngIf="creationType?.value"
        label="Git URL"
        placeholder="https://github.com/Facetscloud"
        [customFormControl]="gitUrl"
        labelSize="4"
        inputSize="7"
        formMargin="4"
        [required]="true"
        [showInfoAsTooltip]="false"
        [disabled]="!creationType?.value"
        missingMsg="Repository URL is required!"
        invalidPatternMsg="Repository URL is invalid!"
        tooltipText="Enter the Git repository URL to link your project."
      ></app-reactive-form-field>

      <!-- Git Ref -->
      <app-reactive-form-field
        *ngIf="creationType?.value"
        label="Git Ref"
        placeholder="Add Branch"
        [customFormControl]="gitReference"
        labelSize="4"
        inputSize="7"
        formMargin="4"
        [required]="true"
        [showInfoAsTooltip]="false"
        [disabled]="!creationType?.value"
        invalidPatternMsg="Commit ID is invalid!"
        tooltipText="Enter the specific Commit ID or Branch Name of the repository."
      ></app-reactive-form-field>

      <!-- Relative Path -->
      <app-reactive-form-field
        *ngIf="creationType?.value"
        label="Relative Path"
        placeholder="Add Path"
        [customFormControl]="relativePath"
        labelSize="4"
        inputSize="7"
        formMargin="4"
        [required]="true"
        [showInfoAsTooltip]="false"
        [disabled]="!creationType?.value"
        tooltipText="Provide the path to the project directory within the repository."
      ></app-reactive-form-field>

      <!-- GitOps message -->
      <!--      <div class="mt-2">-->
      <!--        <app-user-note-alert-->
      <!--          title="After creating your project, streamline code management by connecting your custom Git repository. Navigate to Project Settings to set it up."-->
      <!--        ></app-user-note-alert>-->
      <!--      </div>-->
    </form>
  </nb-card-body>
  <nb-card-footer>
    <app-rbac-button
      label="Create"
      status="primary"
      action="STACK_WRITE"
      class="mr-3"
      [loading]="projectCreationInProgress"
      [disabled]="
        projectForm.invalid ||
        projectCreationInProgress ||
        allowedClouds?.length === 0
      "
      (onClick)="createProject()"
    ></app-rbac-button>
    <button
      nbButton
      size="small"
      (click)="onClickHandleCancel()"
      [disabled]="projectCreationInProgress"
    >
      Cancel
    </button>
  </nb-card-footer>
</nb-card>
